"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchStockPropsToParams = void 0;
var util_1 = require("./util");
exports.fetchStockPropsToParams = function (_a) {
    var pairId = _a.pairId, startDate = _a.startDate, endDate = _a.endDate, interval = _a.interval;
    return ({
        pairId: pairId.join(','),
        startDate: util_1.investingDateUtil.dateToStr(startDate),
        endDate: util_1.investingDateUtil.dateToStr(endDate),
        interval: interval,
    });
};
